import React from 'react';
import { Spin } from 'antd';
import styled from 'styled-components';
import { useLoadingStore } from '../../stores/loading';

export default function GlobalLoading() {
  const { isLoading, loadingText } = useLoadingStore();

  if (!isLoading) {
    return null;
  }

  return (
    <LoadingOverlay>
      <LoadingContainer>
        <Spin size="large" />
        {loadingText && <LoadingText>{loadingText}</LoadingText>}
      </LoadingContainer>
    </LoadingOverlay>
  );
}

// Styled Components
const LoadingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

const LoadingContainer = styled.div`
  background-color: white;
  padding: 32px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  min-width: 200px;
`;

const LoadingText = styled.div`
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 500;
  color: #141413;
  text-align: center;
`;
